'use client'

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

import { URLS } from '@/configs/urls'
import { usePathname } from '@/i18n/routing'
import { schedulePathAwareNonCriticalWork } from '@/lib/perf/scheduleNonCriticalWork'

const Footer = dynamic(() => import('./index'), { ssr: false })

export default function FooterLazy() {
  const pathname = usePathname()
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    return schedulePathAwareNonCriticalWork(pathname, () => {
      setShouldLoad(true)
    })
  }, [pathname])

  if (!shouldLoad || pathname === URLS.JOIN) {
    return null
  }

  return <Footer />
}
